import { useOutletContext, Link } from "react-router-dom";
import Container from "@/components/Container";
import { LogoMark } from "@/components/Logo";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  const { cms } = useOutletContext() || {};
  const a = cms?.about || {};
  const items = a.what_we_buy || [
    "Probate properties",
    "Auction lots",
    "Derelict & abandoned homes",
    "Unmodernised period properties",
    "Distressed sales & quick-sale chains",
    "Under-presented listings",
    "Development plots & land",
  ];
  return (
    <div className="pt-36 pb-32">
      <Container>
        <div className="flex items-center gap-4 mb-10">
          <span className="label-mono">No. 02 — The House</span>
          <span className="h-px w-12 bg-ruby" />
        </div>

        <h1 className="serif-display text-5xl md:text-7xl lg:text-[8rem] text-ink-700 max-w-5xl">
          A property house.<br />
          <span className="serif-italic text-ruby">Not a property shop.</span>
        </h1>

        <div className="mt-24 grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          <div className="lg:col-span-7">
            <p className="text-2xl lg:text-3xl serif-light text-ink-700 leading-[1.35]">
              Rubys.Group acquires homes of character and rare opportunity — and re-imagines them as definitive residences.
            </p>
            <p className="mt-10 text-ink-400 leading-[1.85] text-base lg:text-[1.05rem] max-w-xl">
              Every property begins with a story we wish to tell — period, position, proportion, or possibility. From acquisition through architectural redesign, full renovation, editorial staging and final sale, we manage every stage with the discipline of a fashion house and the patience of a craftsman. The Rubys signature is calm, considered, and unmistakable.
            </p>

            <div className="mt-20">
              <p className="label-mono">What makes a Rubys property</p>
              <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12">
                {[
                  ["01", "Architecturally considered", "Every plan re-drawn before a single trade arrives."],
                  ["02", "Materially confident", "A calm, premium palette — never overdesigned."],
                  ["03", "Editorially presented", "Photography, copy and staging by the in-house studio."],
                  ["04", "Fully resolved", "Snagged, certified, and finished to a Rubys standard."],
                ].map(([n, t, d]) => (
                  <div key={t}>
                    <p className="editorial-numeral text-3xl">{n}</p>
                    <p className="mt-3 serif-light text-2xl text-ink-700">{t}</p>
                    <p className="mt-2 text-sm text-ink-100 leading-relaxed">{d}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
            <div className="surface-cream p-10 border-t-2 border-ruby">
              <LogoMark size={40} className="text-ruby" />
              <p className="label-mono mt-8">What we acquire</p>
              <ul className="mt-8 space-y-5">
                {items.map((it, i) => (
                  <li key={it} className="flex items-baseline gap-5">
                    <span className="editorial-numeral text-xl">{String(i+1).padStart(2,"0")}</span>
                    <span className="serif-light text-xl lg:text-2xl text-ink-700">{it}</span>
                  </li>
                ))}
              </ul>
              <div className="divider-ruby-h my-10" />
              <Link to="/sell" className="btn-link">Have a property to offer <ArrowUpRight size={14} /></Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
